import React, { useState } from 'react';
import { useUserActions } from 'state';
import { FormPage } from 'components/_shared/Page';
import { Paper } from 'components/_shared/Paper';
import { EmailForm } from './components';
import { VerifyCard } from 'components/VerifyCard';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '_constants';

export const ForgotPassword = ({ ...props }) => {
  const { forgotPassword } = useUserActions();
  const [email, setEmail] = useState();
  const history = useHistory();
  const handleClose = () => {
    history.push(ROUTES.AUTH);
  };

  const handleResend = () => forgotPassword({ email });

  return (
    <FormPage {...props} header={false}>
      <Paper padding={4} closeButton={true} handleClose={handleClose}>
        {email ? (
          <VerifyCard email={email} onResend={handleResend} />
        ) : (
          <EmailForm setEmail={setEmail} />
        )}
      </Paper>
    </FormPage>
  );
};
